/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactView = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM5 7a5 5 0 1 1 10 0A5 5 0 0 1 5 7zm.32 10.476C4.435 18.328 4 19.541 4 21v1H2v-1c0-1.857.564-3.644 1.93-4.963C5.296 14.72 7.327 14 10 14c.781 0 1.506.061 2.176.18l-.352 1.97A10.33 10.33 0 0 0 10 16c-2.326 0-3.795.622-4.68 1.476zM17.5 15c2.153 0 4.236 1.236 5.394 3.553l.224.447-.224.447C21.736 21.764 19.654 23 17.5 23s-4.236-1.236-5.394-3.553L11.882 19l.224-.447C13.264 16.236 15.346 15 17.5 15zm-3.356 4c.856 1.372 2.135 2 3.356 2s2.5-.628 3.356-2C20 17.628 18.72 17 17.5 17s-2.5.628-3.356 2z" />
        <path d="M18.75 19a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgContactView as ContactView };
